import PhotosRenderer from './PhotosRenderer';

export default PhotosRenderer;
